import {get} from "lodash"
import BaseService from "./Base"
import {Kit, KitUpdatePayload} from "types/kit"

class KitService extends BaseService {
    async getAll(params = {}) {
        const response = await this.post("/v1/kits/list", params)
        return get(response, "data", [])
    }

    async getById(kitId: number) {
        const response = await this.post(`/v1/kits/list`, {
            filter: {kitIds: [kitId]},
            linkedEntities: true
        })
        return get(response, "data.data[0]", null)
    }

    async create(data: Partial<Kit>): Promise<Kit> {
        const response = await this.post("/v1/kits/create", data)
        return get(response, "data.data", {})
    }

    async updateKit(data: KitUpdatePayload): Promise<Kit> {
        const response = await this.post(`/v1/kits/update`, data)
        return get(response, "data.data", null)
    }

    async deleteKit(kitId: number) {
        const response = await this.post(`/v1/kits/delete`, {kitId})
        return get(response, "data", {})
    }
}

export default KitService
